// extracted by mini-css-extract-plugin
export default {"form":"oSyYLV1X__h0o6VMhmQ5"};